(function () {
  'use strict';
  angular.module('vcconsult')
    .component('openconsultcounter', {
      restrict: 'E',
      bindings: {},
      template: `
        <span class="badge badge-info" ng-bind="vm.counter"  uib-tooltip="Offene Konsultationen"  tooltip-placement="auto"></span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Consult', 'Rlog', 'vertxEventBusService', '$http',
        function ($log, Consult, Rlog, vertxEventBusService, $http) {
          let vm = this;

          const getCounter = function () {
            let query = [{
              $match: {
                open: true,
                active: true
              }
            }, {
              $group: {
                _id: null,
                counter: {$sum: 1}
              }
            }];

            $http.post('/routes/consults/aggregate', query).then(res => {
              vm.counter = 0;
              // $log.debug('**** Counter data: ', res.data );
              if (res.data.counter) {
                vm.counter = res.data.counter;
              }
            }, err => {
              Rlog.error('consult', 'openconsultcounter', 'consult.$aggregate failed', {});
              $log.error(err);
            });
          };

          vm.$onInit = function () {
            getCounter();
          }; // $onInit()

          // listen for consult updates
          vertxEventBusService.on('consults.update', {}, getCounter);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('consults.update', {}, getCounter);
          };

        }
      ] // controller
    }); // component

// klammerfriedhof
}());
